/**
 * Vendor Application container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import React from 'react';
import vendorApplicationActions from './actions';
import vendorAttributionActions from '../VendorAttribution/actions';
import VendorApplication from '../../Components/VendorApplication/VendorApplication';
import { vendorSelector, publicFilesUrlsSelector } from './selectors';
import { currentUserSelector, loggedInSelector } from '../App/selectors';
import { vendorAttributesErrorSelector } from '../VendorAttribution/selectors';
import promisifyActions from '../../Lib/Utils/promisify-actions';
import ComplianceAPI from '../../Lib/Api/compliance';
import ValidationAPI from '../../Lib/Api/validation';
import { userSelector } from '../User/selectors';

const {
  updateVendor,
  updateVendorBanking,
  createVendorNetSuite,
  updateVendorNetSuite,
  createVendorContact,
  updateVendorContact,
  removeVendorContact,
  submitVendor,
} = vendorApplicationActions;

function VendorApplicationComponent(props) {
  return (
    <VendorApplication
      {...props}
      uploadApprovalSignatures={ComplianceAPI.uploadApprovalSignatures}
      validateIBAN={ValidationAPI.validateIBAN}
      validateBIC={ValidationAPI.validateBIC}
      validateTIN={ValidationAPI.validateTIN}
    />
  );
}

/**
 * Properties to be provided to the Vendor Application component
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  isLoggedIn: loggedInSelector(state),
  currentUser: currentUserSelector(state),
  vendor: vendorSelector(state),
  publicFilesUrls: publicFilesUrlsSelector(state),
  vendorAttributesError: vendorAttributesErrorSelector(state),
  user: userSelector(state),
});

/**
 * Actions to be dispatched
 * @param {function} dispatch function to dispatch vendor application actions
 */
const mapDispatchToProps = (dispatch) => ({
  updateVendor: (userId, formData, fileUpload) =>
    dispatch(updateVendor(userId, formData, fileUpload)),
  updateVendorBanking: (userId, formData) =>
    dispatch(updateVendorBanking(userId, formData)),
  createVendorNetSuite: (userId) => dispatch(createVendorNetSuite(userId)),
  updateVendorNetSuite: (userId, vendor) =>
    dispatch(updateVendorNetSuite(userId, vendor)),
  createVendorContact: (userId, contact, reInstanciateDeletedUser) =>
    dispatch(createVendorContact(userId, contact, reInstanciateDeletedUser)),
  updateVendorContact: (userId, contactId, updates) =>
    dispatch(updateVendorContact(userId, contactId, updates)),
  removeVendorContact: (userId, contactId) =>
    dispatch(removeVendorContact(userId, contactId)),
  submitVendor: (userId) => dispatch(submitVendor({ userId })),
  updateVendorAttributes: (userId, update) =>
    dispatch(vendorAttributionActions.updateVendorAttributes(userId, update)),
});

/**
 * Connects state to the Vendor Application component
 * @param {object} mapStateToProps data object to become props for the Vendor Application component
 * @param {object} mapDispatchToProps Vendor Application actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )(VendorApplicationComponent),
);
